import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import History from "@/pages/History";
import UserManagement from "@/pages/UserManagement";
import StaffManagement from "@/pages/StaffManagement";
import DeviceManagement from "@/pages/DeviceManagement";
import LoanSettings from "@/pages/LoanSettings";
import EmailSettings from "@/pages/EmailSettings";

function ProtectedRoute({ children, adminOnly = false }) {
  const { staff, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }
  
  if (!staff) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && staff.role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function AppRoutes() {
  const { staff } = useAuth();
  
  return (
    <Routes>
      <Route path="/settings/loans" element={<ProtectedRoute adminOnly><LoanSettings /></ProtectedRoute>} />
      <Route 
        path="/login" 
        element={staff ? <Navigate to="/" replace /> : <Login />} 
      />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/history" 
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/devices" 
        element={
          <ProtectedRoute adminOnly>
            <DeviceManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/staff" 
        element={
          <ProtectedRoute adminOnly>
            <StaffManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings/email" 
        element={
          <ProtectedRoute adminOnly>
            <EmailSettings />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F8FAFC]">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
